import { Endpoint } from '../endpoint';

export const MasterRecord = new Endpoint('master_record');
